import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-ballot-icon',
    templateUrl: './ballot-icon.component.html',
    styleUrls: ['./ballot-icon.component.scss']
})
export class BallotIconComponent extends AbstractIcon {
    constructor() {
        super();

        this.height = 24;
        this.width = 24;
    }
}
